export const errorDuplicateAttendant =
  "Ya existe un registro para este usuario en la sesión actual.";

export const unknownErrorOnAttendance =
  "Lo sentimos, no podemos completar tu solicitud en este momento. Por favor, inténtalo de nuevo más tarde.";
